import isBlank from '@sedan-utils/is-blank';
import { IValueFormatter } from '../../../src/locale/types';

export const emptyOrFormatted =
  (emptyValue: string, formatter: IValueFormatter): IValueFormatter =>
  ({ value }) =>
    isBlank(value) ? emptyValue : formatter({ value });
